import { createContext, useContext } from 'react';
export const PlpContext = createContext(null);
PlpContext.displayName = 'PlpContext';
/**
 * React Hook to access state provided by CioPlp provider.
 * Note: Should only be used by components nested under a CioPlp provider
 */
export function useCioPlpContext() {
    return useContext(PlpContext);
}
